<template>
  <div class="product-card-container">
    <div class="content">
      <div class="info">
        <span class="date">{{ slotStartDate }}</span>
        <span class="title">{{ eventName }} </span>
      </div>
      <div>
          <span class="price"> {{ product.price | toDollar }} </span>
      </div>
      <div class="d-flex justify-content-end input-box">
        <el-input-number size="mini" v-model="numberOfTickets" @change="updateCart()" v-if="!isSoldOut && isInDateRange" :min="0"></el-input-number>
        <span class="sold-out" v-else>Sold Out</span>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: 'EventProductCard',
  props: {
    product: {
      type: Object,
      required: true,
    },
    eventName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      numberOfTickets: 0,
    };
  },
  filters: {
    toDollar(value) {
      return `$${parseInt(value / 100).toFixed(2)}`;
    },
  },
  computed: {
    isInDateRange() {
      const { product } = this;
      const { bookingDateRange } = product;
      const { from, to } = bookingDateRange;
      const now = moment();
      return now.isBetween(from, to);
    },
    slotStartDate() {
      return moment(this.product.effectiveDate.from).format('ddd DD/MM - HH:mm a');
    },
    isSoldOut() {
      const { maximum, booking } = this.product;
      return booking && booking.length >= maximum;
    },
  },
  methods: {
    updateCart() {
      this.$emit('update-cart', {
        product: this.product,
        quantity: this.numberOfTickets,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .product-card-container {
    background: transparent;
    margin: 0 0 1rem 0;
    padding: 0.5rem 0.5rem;
    border-radius: 8px;
    border: 1px solid #e9e5e5;
    transition: all 0.2s ease-in-out;
    display: flex;
    align-items: center;

    ::v-deep.el-input__inner {
      border: none;
      background: transparent;
      text-align: center !important;
    }

    ::v-deep.el-input-number {
      width: 100px;
    }

    ::v-deep.el-input-number__decrease, ::v-deep.el-input-number__increase {
      border-radius: 200px;
      box-shadow: 0px 2px 14px rgba(83, 89, 144, 0.14);
      border: 1px solid lightgray;
    //   transition: all 0.2s ease-in-out;
      &:not(.is-disabled):hover {
        background: $highlight;
        color: white;
      }
      // &.is-disabled {
      //   display: none;
      // }
    }

    .content {
      display: grid;
      align-items: center;
      width: 100%;
      grid-template-columns: 3fr 1fr 1fr;
    //   gap: 1.5vmax;

      .title {
        display: block;
        padding-top: 0.2rem;
        font-size: 1rem;
        font-weight: bold;
        color: #333;
      }

      .price {
        display: inline-block;
        color: rgb(166, 166, 166);
        font-size: 1rem;
      }

      .date {
        color: rgb(255, 70, 70);
        font-size: 0.8rem;
      }

      .buy-button {
        background: $primary;
        color: white;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 0.5rem;
        &:hover {
          cursor: pointer;
        }
      }
      .input-box {
        width: 100% !important;
        text-align: center;
      }

      .sold-out {
        color: #999;
        font-size: 0.8rem;
        text-decoration: italic;
        padding: 0.5rem;
        border-radius: 20px;
        background: #f5f5f5;
      }
    }

  }
</style>
